/**
 * Returns true if the value is invalid for the given property schema.
 * For enum: value must be in property.enum and not in disabled_values.
 * For number: value must be within minimum/maximum.
 * For boolean: value must be defined if default exists.
 */
export function isSchemaValueInvalid(value, propSchema, disabledValues = []) {
  if (propSchema?.default === undefined) {
    return false
  }

  if (Array.isArray(propSchema.enum)) {
    if (value === undefined || value === null){
      return true
    }

    if (!propSchema.enum.includes(value)) {
      return true
    }

    if (disabledValues.includes(value)) {
      return true
    }

    return false
  }

  const hasMinMax = typeof propSchema.minimum === 'number' || typeof propSchema.maximum === 'number'
  if (propSchema.type === 'integer' || propSchema.type === 'number' || hasMinMax) {
    const { minimum, maximum } = propSchema
    if (value == null || value === '') {
      return true
    }

    const valueAsNumber = Number(value)
    if (typeof minimum === 'number' && valueAsNumber < minimum) {
      return true
    }

    if (typeof maximum === 'number' && valueAsNumber > maximum) {
      return true
    }

    return false
  }

  if (disabledValues.length > 0 && disabledValues.includes(value)) {
    return true
  }

  if (propSchema.type === 'boolean') {
    if (value === undefined && propSchema.default !== undefined) {
      return true
    }

    return false
  }

  return false
}
